import * as React from 'react';
const MenopausaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <circle cx={108.74} cy={91.26} r={21.99} className="prefix__cls-2" />
    <path
      d="m69.26 130.74 23.93-23.93M69.26 113.99l16.75 16.75"
      className="prefix__cls-2"
    />
    <path d="M102.96 83.46v15.6M114.52 83.46v15.6" className="prefix__cls-1" />
  </svg>
);
export default MenopausaIcon;
